import React, { useEffect } from 'react';

const SEO = ({
    title,
    description,
    keywords,
    image,
    url,
    type = 'website',
    author = 'Ankara Merkez Far',
    locale = 'tr_TR',
    siteName = 'Ankara Merkez Far'
}) => {
    useEffect(() => {
        // Update document title
        if (title) {
            document.title = title;
        }

        // Meta tags
        const metaTags = {
            description: description || 'Ankara Merkez Far - Araç Far ve Stop Tamiri',
            keywords: keywords || 'Ankara far tamircisi, far camı değişimi, far mercek değişimi, stop lambası tamiri',
            author: author,
            robots: 'index, follow',
            googlebot: 'index, follow',
            language: 'Turkish',
        };

        // Set meta tags
        Object.entries(metaTags).forEach(([name, content]) => {
            let metaElement = document.querySelector(`meta[name="${name}"]`);
            if (!metaElement) {
                metaElement = document.createElement('meta');
                metaElement.setAttribute('name', name);
                document.head.appendChild(metaElement);
            }
            metaElement.setAttribute('content', content);
        });

        // Open Graph tags
        const ogTags = {
            'og:title': title || 'Ankara Merkez Far',
            'og:description': description || 'Ankara nın en güvenilir far ve stop tamir servisi',
            'og:image': image || '/logo.jpg',
            'og:url': url || 'https://ankaramerkezfar.com/',
            'og:type': type,
            'og:locale': locale,
            'og:site_name': siteName,
        };

        Object.entries(ogTags).forEach(([property, content]) => {
            let metaElement = document.querySelector(`meta[property="${property}"]`);
            if (!metaElement) {
                metaElement = document.createElement('meta');
                metaElement.setAttribute('property', property);
                document.head.appendChild(metaElement);
            }
            metaElement.setAttribute('content', content);
        });

        // Twitter Card tags
        const twitterTags = {
            'twitter:card': 'summary_large_image',
            'twitter:url': url || 'https://ankaramerkezfar.com/',
            'twitter:title': title || 'Ankara Merkez Far',
            'twitter:description': description || 'Ankara nın en güvenilir far ve stop tamir servisi',
            'twitter:image': image || '/logo.jpg',
        };

        Object.entries(twitterTags).forEach(([name, content]) => {
            let metaElement = document.querySelector(`meta[name="${name}"]`);
            if (!metaElement) {
                metaElement = document.createElement('meta');
                metaElement.setAttribute('name', name);
                document.head.appendChild(metaElement);
            }
            metaElement.setAttribute('content', content);
        });

        // Cleanup function to reset on unmount
        return () => {
            // Don't remove tags on unmount to preserve last page's SEO
        };
    }, [title, description, keywords, image, url, type, author, locale, siteName]);

    return null;
};

export default SEO;
